import { Injectable } from '@angular/core';
import { AuthConfig, OAuthService } from 'angular-oauth2-oidc';
import {environment} from "../../environments/environment";
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  constructor(private oauthService: OAuthService) {
    this.oauthService.configure(this.authConfig);
    this.oauthService.loadDiscoveryDocument().then(() => {
      this.oauthService.tryLogin().then(() => {
        if (!this.oauthService.hasValidAccessToken()) {
          this.login();
        } else {
          this.oauthService.setupAutomaticSilentRefresh();
        }
      });
    });
  }
  authConfig: AuthConfig = {
    responseType: 'code',
    scope: 'openid profile email',
    redirectUri: window.location.origin + "/ricerca-schede",
    oidc: true,
    requestAccessToken: true,
    showDebugInformation: environment.authDebug,
    strictDiscoveryDocumentValidation: false,
    //useSilentRefresh: true,
    //silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',
    issuer: `${environment.KEYCLOAK_URL}realms/${environment.KEYCLOAK_REALM}`,
    clientId: environment.KEYCLOAK_CLIENT_ID,
    requireHttps: environment.authRequireHttps,
    //silentRefreshTimeout: 100
  };


  public login(): void {
    this.oauthService.initLoginFlow();
  }

  public logout(): void {
    this.oauthService.logOut();
  }

  public get token() {
    return this.oauthService.getAccessToken();
  }

  public get isAuthenticated(): boolean {
    return this.oauthService.hasValidAccessToken();
  }
  public get userName(): string | null {
    const claims = this.oauthService.getIdentityClaims();
    if (!claims) {
      return null;
    }
    return (claims as any).name;
  }

  public getCheckEnableToFlusso(utente: any):boolean {
    return utente.flussiUtente?.find((flusso: any) => flusso.codiceFlusso == "C_MORTEM") ?? false;
  }

  public getCheckEnableOperatore(utente: any):boolean {
    if (utente.nomeRuolo == "operatore-asl") {
      return true;
    } else{
      return false;
    } 
  }

  public getCheckEnableOperatoreRegione(utente: any): boolean {
    if (utente.nomeRuolo == "operatore-regione") {
      return true;
    } else {
      return false;
    }
  }
}
